function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import Icon from "./Icon";
import colors from "../../colors";

var CheckIcon = function CheckIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors.pineGreen : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement(Icon, _extends({
    width: "12",
    height: "10",
    viewBox: "0 0 12 10",
    fill: color,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("path", {
    d: "M10.418.5l-5.59 6.796-3.246-3.46L.5 4.94C3.385 7.979 4.848 9.5 4.888 9.5c.04 0 2.244-2.653 6.612-7.96L10.418.5z"
  }));
};

export default CheckIcon;